import { createContext, Dispatch, FC, PropsWithChildren, SetStateAction, useState } from 'react';

interface ContextProps {
	isCollapsed: boolean;
	setIsCollapsed: Dispatch<SetStateAction<boolean>>;
}

// eslint-disable-next-line react-refresh/only-export-components
export const SidebarContext = createContext<ContextProps>({
	isCollapsed: false,
	setIsCollapsed: () => false,
});

export const SidebarProvider: FC<PropsWithChildren> = ({ children }) => {
	const [isCollapsed, setIsCollapsed] = useState(false);

	return (
		<SidebarContext.Provider
			value={{
				isCollapsed,
				setIsCollapsed,
			}}
		>
			{children}
		</SidebarContext.Provider>
	);
};
